import { Stock } from '@stockcare-storage/stock/stock';
import { Injectable } from '@angular/core';
import { Patient } from '@stockcare-storage/patient/patient';
import { Theme } from '@stockcare-storage/theme/theme';
import { User } from '@stockcare-storage/user/user';
import { InternalTable } from './internal-table';
import { BasketStaging } from '@stockcare-storage/basket-staging/basketStaging';
import { Doctor } from '@stockcare-storage/doctor/doctor';
import { Procedure } from '@stockcare-storage/procedure/procedure';
import { Service } from '@stockcare-storage/service/service';
import { TheatrePatient } from '@stockcare-storage/theatre-patient/theatre-patient';
import { QueueItem } from '@stockcare-storage/queue/queue';
import { TheatrePatientServices } from '@stockcare-storage/theatre-patient-services/theatre-patient-services';
import { TheatrePatientMaterials } from '@stockcare-storage/theatre-patient-materials/theatre-patient-materials';
import { Pack } from '@stockcare-storage/pack/pack';
import { PhysicalLocationOperatingRoom } from '@stockcare-storage/physical-location-operating-room/physical-location-operating-room';
import { ChecklistProgress } from '@stockcare-storage/checklist/checklist-progress';
import { ChecklistQuestionStorage } from '@stockcare-storage/checklist/checklist-question-storage';
import { WhoChecklistStorage } from '@stockcare-storage/checklist/who-checklist-storage';

@Injectable({
  providedIn: 'root'
})
export class InternalContext {
  readonly tables: InternalTable[] = [];

  constructor() {
    this.tables.push(User.getTableDefinition());
    this.tables.push(Theme.getTableDefinition());
    this.tables.push(Patient.getTableDefinition());
    this.tables.push(Stock.getTableDefinition());
    this.tables.push(BasketStaging.getTableDefinition());
    this.tables.push(Doctor.getTableDefinition());
    this.tables.push(Procedure.getTableDefinition());
    this.tables.push(Service.getTableDefinition());
    this.tables.push(TheatrePatient.getTableDefinition());
    this.tables.push(QueueItem.getTableDefinition());
    this.tables.push(TheatrePatientServices.getTableDefinition());
    this.tables.push(TheatrePatientMaterials.getTableDefinition());
    this.tables.push(Pack.getTableDefinition());
    this.tables.push(PhysicalLocationOperatingRoom.getTableDefinition());
    this.tables.push(ChecklistProgress.getTableDefinition());
    this.tables.push(ChecklistQuestionStorage.getTableDefinition());
    this.tables.push(WhoChecklistStorage.getTableDefinition());
  }

  getAllTableDefinitions(): InternalTable[] {
    return this.tables;
  }
}
